import { AgGridReact } from 'ag-grid-react'
import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { rolecreate, rolelist, roleupdate, rolevalidate, roleview } from '../../../services/master';
import { toast } from 'react-toastify';

export const ListRole = () => {
    const navigate = useNavigate();
    const [fbranch, setFBranch] = useState("");
    const [fbid, setFBid] = useState("");
    const [errmsg, setErrMsg] = useState("");
    const [filterProduct, setFilterProduct] = useState([]);

    const columnDefs = [

        {
            headerName: "Role",
            field: "role_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },

        {
            headerName: "Actions",
            field: "id",
            sortable: true,
            resizable: true,
            filter: false,
            floatingFilter: false,
            cellStyle: { textAlign: "left" },
            cellRenderer: function (params) {
                return (
                    <div className="text-center">
                        <a
                            onClick={() =>
                                viewshow(params.value)
                            }
                            className="btn-sm btn-info me-2"
                        >
                            <i className="fa fa-edit"></i>
                        </a>

                    </div>
                );
            },
        },
    ];

    function viewshow(vid) {
        setFBid(vid);
        setFBranch("");
        setShow(true);
    
        setErrMsg("");
        roleview(vid).then((response) => {
          if (response.status === true) {
            setFBranch(response.data.role_name);
          }
        });
    }

    useEffect(() => {
        funlist();
    }, []);

    function funlist() {
        setFilterProduct([]);
        rolelist().then((res) => {
            if (res.status === true) {
                setFilterProduct(res.data);
            }
        });
    }
    const [show, setShow] = useState(false);
    function handleShow() {
        setFBid("");
        setFBranch("");
        setErrMsg("");
        setShow(true);
    }

    function handleclose() {
        setShow(false);
        setFBid("");
        setFBranch("");
        setErrMsg("");
    }

    function handlebranch(e) {
        e.preventDefault();
        setErrMsg("");
        if (fbranch !== "") {
            const temp = new FormData();
            temp.append("name", fbranch);
            temp.append("id", fbid);

            rolevalidate(temp).then((response) => {
                if (response.status === false) {
                    setErrMsg(response.message);
                } else {
                    const tempData = new FormData();
                    tempData.append("name", fbranch);
                    if (fbid === "") {
                        rolecreate(tempData).then((response) => {
                            if (response.status === true) {
                                handleclose();
                                funlist();
                                toast.success(response.message);
                            } else {
                                setErrMsg(response.data.message);
                            }
                        });
                    } else {
                        tempData.append("id", fbid);
                        roleupdate(tempData).then((response) => {
                            if (response.status === true) {
                                handleclose();
                                funlist();
                                toast.success(response.message);
                            } else {
                                setErrMsg(response.data.message);
                            }
                        });
                    }
                }
            });
        } else {
            setErrMsg("Please Enter Role");
        }
    }

    return (
        <div>
            <div className="page-header">
                <h2 className="main-content-title tx-24 mg-b-5">Role</h2>
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <a>Master</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                        Role
                    </li>
                </ol>
            </div>
            <div className='d-flex justify-content-end'>
                <a className='btn btn-success' onClick={handleShow}>Add Role</a>
            </div>
            <div className="ag-theme-alpine ag-style mt-2">
                <AgGridReact
                    columnDefs={columnDefs}
                    rowData={filterProduct}
                    pagination="true"
                    paginationPageSize="10"
                    sortingOrder={["asc", "desc"]}
                    suppressDragLeaveHidesColumns={true}
                />
            </div>

            <Modal show={show} onHide={() => setShow(false)}>
                <Modal.Header>
                    <h4>{fbid ? "Role Detail" : "Add Role"}</h4>
                </Modal.Header>
                <Modal.Body>
                    <div className='row'>
                        <div className="col-md-12">
                            <div className="mb-3">
                                <label className="form-label">Role <span className="text-danger"> *</span></label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Role"
                                    value={fbranch}
                                    onChange={(e) => setFBranch(e.target.value)}
                                />
                            </div>
                        </div>
                        {errmsg && <span className='text-danger'>{errmsg}</span>}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <a className='btn btn-success' onClick={handlebranch}>{fbid ? "Update" : "Submit"}</a>
                    <a className='btn btn-info' onClick={() => setShow(false)}>Close</a>
                </Modal.Footer>
            </Modal>
        </div>
    )
}
